"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliverFactory = exports.sendFactory = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
function sendFactory(url) {
    return function send(id) {
        return abortable_fetch_1.abortableFetch(`${url}/${id}/send`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.sendFactory = sendFactory;
function deliverFactory(url) {
    return function deliver(id) {
        return abortable_fetch_1.abortableFetch(`${url}/${id}/deliver`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.deliverFactory = deliverFactory;
//# sourceMappingURL=dispatches-api.js.map